import request from '@/axios'


export function fetchSchoolTypeApi(){
    return request({
        url: 'customer_type_list',
        method: 'GET'
    })
}


export function fetchplanDetailsApi(planId) {
    return request({
        url: `plan_details/${planId}`,
        method: 'GET'
    })
}


export function listPlanApi() {
    return request({
        url: 'list_plan',
        method: 'GET'
    })
}

export function listCountryApi() {
    return request({
        url: 'country_list',
        method: 'GET'
    })
}


export function createUserApi(payload) {
    return request({
        url: 'school_registration',
        method: 'POST',
        data: payload
    })
}


export function subscribePlan(payload) {
    return request({
        url: 'subscribe',
        method: 'POST',
        data: payload
    })
}